export default "/assets/images/ten.d9e2a843ffaff269.svg";